import { RequestStatusEnum } from "#/services/bridge/bridge.types";

export const BRIDGE_STATUS_CONFIG: Record<
  RequestStatusEnum,
  {
    label: string;
    color: string;
    description: string;
  }
> = {
  [RequestStatusEnum.PENDING]: {
    color: "text-textSecondary",
    label: "Pending",
    description:
      "The request has been submitted but not yet picked up by a solver.",
  },
  [RequestStatusEnum.ASSIGNED]: {
    color: "text-warning",
    label: "Assigned",
    description:
      "A solver has been assigned and is preparing to execute the request.",
  },
  [RequestStatusEnum.EXTRACTED]: {
    color: "text-brandBlue",
    label: "Extracted",
    description:
      "Funds have been extracted from the source chain and execution is in progress.",
  },
  [RequestStatusEnum.FULFILLED]: {
    color: "text-success",
    label: "Fulfilled",
    description:
      "The request was successfully executed on the destination chain.",
  },
  [RequestStatusEnum.SETTLED]: {
    color: "text-success",
    label: "Settled",
    description:
      "All operations have been completed and confirmed on both chains.",
  },
  [RequestStatusEnum.EXPIRED]: {
    color: "text-error",
    label: "Expired",
    description: "The request expired before it could be processed.",
  },
  [RequestStatusEnum.CANCELLED]: {
    color: "text-error",
    label: "Cancelled",
    description: "The request was cancelled by the user or the system.",
  },
  [RequestStatusEnum.REFUNDED]: {
    color: "text-warning",
    label: "Refunded",
    description:
      "The refund was processed and funds were sent to the appropriate address.",
  },
};
